module.exports = __webpack_public_path__ + "static/media/smoke.6eabb1f1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Images/smoke.jpeg
// module id = 639
// module chunks = 0